import { render, staticRenderFns } from "./MapLayerLegend.vue?vue&type=template&id=22a07702&scoped=true"
import script from "./MapLayerLegend.vue?vue&type=script&lang=ts"
export * from "./MapLayerLegend.vue?vue&type=script&lang=ts"
import style0 from "./MapLayerLegend.vue?vue&type=style&index=0&id=22a07702&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a07702",
  null
  
)

export default component.exports